import type { FC, ReactElement } from 'react';
import type { RequestTemplate } from '@/model/Request.model';
import { DateRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import FormRender from '@/components/UI/FormRender';
import Summary, { SummaryItem } from '@/components/UI/Summary';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form@latest';
import { _isNotEmpty } from '@/littledash';

interface RequestSummaryProps {
  ActionButtons: ReactElement;
  onSubmit: () => void;
  request: {
    form_data: Record<string, unknown>;
    due_date?: string;
    samples: Array<{ id: string }>;
  };
  requestTemplate: RequestTemplate;
}

const RequestSummary: FC<RequestSummaryProps> = ({ ActionButtons, onSubmit, request, requestTemplate }) => {
  const formMethods = useForm({
    defaultValues: request.form_data,
  });

  const groups = requestTemplate.form.groups.map((group) => ({
    ...group,
    fields: Array.isArray(group.fields) ? group.fields : [],
  }));

  return (
    <div data-test-component="RequestSummary" data-test-element="container">
      <FormProvider {...formMethods}>
        <FormRender groups={groups} submitted hookFormVersion="latest" />
      </FormProvider>
      <div className="mw7 w-100">
        <Summary>
          <SummaryItem label="Due date">
            <DateRenderer value={request.due_date} defaultResponse="-" />
          </SummaryItem>
        </Summary>
        <Summary title="Samples">
          <SummaryItem label="Total samples">{_isNotEmpty(request.samples) ? request.samples.length : 0}</SummaryItem>
        </Summary>
      </div>

      {React.cloneElement(ActionButtons, { onOk: () => onSubmit() })}
    </div>
  );
};

export default RequestSummary;
